import { FormCheckboxGroupGroups } from '@/hooks/stays/useStaysListingAmenities'
import { apiClient } from '@/lib/api/client'

class StListingAmenitiesRepository {
  private static instance: StListingAmenitiesRepository
  private readonly endpoint: string

  constructor(endpoint: string = 'stays-listing-amenities') {
    this.endpoint = endpoint
  }

  public static getInstance(): StListingAmenitiesRepository {
    if (!this.instance) {
      this.instance = new StListingAmenitiesRepository()
    }
    return this.instance
  }

  async getAll(_params?: unknown): Promise<FormCheckboxGroupGroups[]> {
    return apiClient.invoke<FormCheckboxGroupGroups[]>(this.endpoint, {
      method: 'GET',
    })
  }
}

export const stListingAmenitiesRepository =
  StListingAmenitiesRepository.getInstance()
